import script from "./Overlay.vue?vue&type=script&setup=true&lang=js"
export * from "./Overlay.vue?vue&type=script&setup=true&lang=js"

import "./Overlay.vue?vue&type=style&index=0&id=707252b2&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-707252b2"]])

export default __exports__